import React from "react";


export const ClientTypes = {
  ISV : "ISV",
  Company : "Company",
  Enterprise : "Enterprise",
  AccService : "AccService",
  EndClient : null
}

export const CustomerRelations = {
  AdminByCustomer : "AdminByCustomer",
  SupportByDDD : "SupportByDDD",
  EIOL : "EIOL",
  None : null
}

export const CustomerType = {
  ISVCustomer : "ISVCustomer",
  AccCustomer : "AccSCustomer"
}

export const Domain = {
  DDDInvoices : "DDDInvoices",
  EInvoices : "EInvoices",
}

/**
 * Session settings that define whole behaviour of admin page
 * https://onedrive.live.com/edit.aspx?resid=A98E7B32B1C3342C!107823&ithint=file%2cdocx&wdo=2&authkey=!AKhG6a0pPW9ZKus
 * 
 * ClientType: ISV| Company| Enterprise| AccService| null
 * isTransformer: boolean
 * isIntegrator: boolean
 * ISVCustomer:string (Id)
 * AccCustomer:string (Id)
 * isBuilder:boolean
 * CustomerRelaton: AdminByCustomer|SupportByDDD|EIOL|null
 */
const defaultValue = {
  isLoaded : false,
  setIsLoaded : (bool) => {},
  isPublic : false,
  setIsPublic : (bool) => {},
  mainOrgId: "",
  mainOrgUsername: "",
  setMainOrgHandler: (id, name) => {},
  clientOrgId: "",
  setClientOrgHandler: (id) => {},
  connectionKey: "",
  setConnectionKey: (key) => {},
  setConnKeyHandler : (key) => {},
  connectionKeyMode : null,
  setConnectionKeyModeHandler : (string) =>{},
  modeREI : null,
  setModeREIHandler : (string) =>{},
  isMaintainer: null,
  onIsMaintainerHandler: (bool) => {},
  isTrustee: null,
  setIsTrusteeHandler: (bool) => {},
  isSuperUser : null,
  setIsSuperUserHandler : (bool) => {},
  mainOrgCountry: "",
  setMainCountryHandler: (country) => {},
  aboutOrgId : null,
  setAboutOrgIdHandler : (id) => {},
  roles : [],

  //EU_AOrg
  clientType : null,
  setClientTypeHandler : (type) => {}, //ISV, Company, Enterprise, AccService, null (null means end client)
  isTransformer : null,
  setIsTransformerHandler : (bool) => {},
  isIntegrator : null,
  setIsIntegratorHandler : (bool) => {},
  ISVCustomer : null,
  setISVCustomerHandler : (bool) => {},
  AccCustomer : null,                     //AccSCusomer in extended session
  setAccCustomerHandler : (string) => {},
  isBuilder : null,
  setIsBuilderHandler : (bool) => {},
  customerRelation : null,
  setCustomerRelationHandler : (string) => {}, //AdminByCustomer|SupportByDDD|EIOL|null
  domain : null,
  setDomainHandler : (string) => {},
  getRoles : () => {},
  integrationDevice : null,
  setIntegrationDeviceHandler : (string) => {},
  defaultDevice :  null,
  setDefaultDeviceHandler : (string) => {},
  defaultDeviceMode : null,
  setDefaultDeviceModeHandler : (string) =>{},

  integrationNotFinished : null,
  setIntegrationNotFinishedHandler : (bool) => {},
  
  sessionInfo : null,
  setSessionInfoHandler : () => {},
  // mainOrgTransfId: "",
  // setMainOrgTransId: (id) => {},
};

export const OrgIdContext = React.createContext(defaultValue);
